import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { connectBetSlipDesktop } from "./BetSlipDesktop.connect";
import BetPlacing from "../BetPlacing/BetPlacing";
import BetPlacingPopover from "../BetPlacingPopover/BetPlacingPopover";
import OpenBets from "../OpenBets/OpenBets";


const BetSlipDesktop = ({
  betPlacing,
  actions,
  openBets,
  eventOpenBets,
  allEventsOpenBets,
  auth,
  user,
  cashoutPopUp,
}) => {
  const [isOpenBets, setIsOpenBets] = useState(false);
  const [isThisEvent, setIsThisEvent] = useState(
    localStorage.getItem("page")?.indexOf("event-page") < 0 ? false : true
  );
  const setInfoDispatch = useSelector((state) => state.openBetsList.detailed);
  const setThisEventDispatch = useSelector((state) => state.openBetsList.event);
  const refBetPopover = useRef(null);
  const width = window.innerWidth;
  // const history = useHistory();
  const isPopUpOpenDispatch = useSelector(
    (state) => state.editStakesPopUp.isOpen
  );
  

  useEffect(() => {
    actions.setThisEvent(false);
    // if (!isThisEvent) {
    // }
  }, [isOpenBets]);


  useEffect(() => {
    if(!!betPlacing?.market && !cashoutPopUp?.isOpen) {
      setIsOpenBets(false);
    }else{
      setIsOpenBets(true);
    }
  }, [betPlacing, cashoutPopUp]);

  useEffect(() => {
    if (!betPlacing.betPlacingPopoverStage2) {
      setIsOpenBets(true);
    }
  }, [betPlacing.betPlacingPopoverStage2]);

  useEffect(() => {
    setIsThisEvent(
      localStorage.getItem("page")?.indexOf("event-page") < 0 ? false : true
    );
  }, [isOpenBets]);


  const cancelBetPopover = () => {
    if (refBetPopover.current) {
      refBetPopover.current.dismiss();
    }
    setTimeout(() => {
      if (refBetPopover.current) {
        refBetPopover.current.dismiss();
      } else {
        actions.setShowBetPlacingPopover(false);
      }
    }, 100);
  };

  return (
    <>
      <div className=" w-full   flex flex-col gap-y-1 py-2">
        <div className=" w-full flex items-center gap-1">
          <div className="flex gap-1 w-3/4 border rounded-lg p-0.5 border-ternary3">
            <button 
              className={`text-xs w-full capitalize whitespace-nowrap rounded p-2 ${!isOpenBets? 'bg-bg_Secondary text-text_Quaternary' : 'bg-bg_Quaternary text-text_Secondary'}`}
              onClick={() => {setIsOpenBets(false);}}
            >
              Betslip
            </button>
            <button 
              className={`text-xs w-full capitalize whitespace-nowrap rounded p-2 ${isOpenBets? 'bg-bg_Secondary text-text_Quaternary' : 'bg-bg_Quaternary text-text_Secondary'}`}
              onClick={() => {setIsOpenBets(true);}}
            >
              Open Bets
            </button>
          </div>
          {auth&&
            <button
              className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out text-xs  capitalize whitespace-nowrap rounded py-2 px-3 bg-bg_Secondary text-text_Quaternary cursor-pointer"
              type="button"
              onClick={() => {
                if(!auth) actions.setLoginNew(true)
                else actions.setIsOpen(!isPopUpOpenDispatch)
              }}
            >
              Edit Stakes
            </button>
          }
        </div>


        {(isOpenBets)?
          <>
            {!auth?
              <h4 className=" text-sm font-lato text-center py-4 text-white">
                Please login to see your open bets. 
                <span 
                  className="pl-1 cursor-pointer hover:underline"
                  onClick={() => {actions.setLoginNew(true)}}
                  style={{
                    color:"#ef8402"
                  }}
                >Login</span>
              </h4>
              :
              <>
                <OpenBets openBets={openBets?.openBets} isEvent={true} redirect={true} id={"openBetsRightSide"} />
              </>
            }
          </>
          :
          <>
            <div className="relative">
              <BetPlacing onClose={()=>{setIsOpenBets(true)}} />


              {(width >= 1024 && betPlacing.showBetPlacingPopover)&&
                <BetPlacingPopover
                  cancel={cancelBetPopover}
                  refBetPopover={refBetPopover}
                  open={betPlacing.showBetPlacingPopover}
                />
              }
            </div>
          </>
        }
      </div>
    </>
  );
};

export default connectBetSlipDesktop()(BetSlipDesktop);
